exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrapper[data-v-47d0390f] {\n    overflow-x: hidden;\n}\n.table-h[data-v-47d0390f] {\n    font-size: 15px;\n    font-weight: 900;\n    color: #2c2d4a;\n    background: #f8f8f8;\n    border-bottom: solid 1px #e9eaec;\n}\n.content[data-v-47d0390f] {\n    border: 1px solid #e9eaec;\n    border-radius: 5px;\n}\n", ""]);

// exports
